import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  CalendarOutlined,
  CarOutlined,
  ClearOutlined,
  CoffeeOutlined,
  EnvironmentOutlined,
  SkinOutlined,
  SunOutlined,
  ToolOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  EuroOutlined,
  FileTextOutlined,
  HeartOutlined,
  HomeOutlined,
  KeyOutlined,
  MedicineBoxOutlined,
  MessageOutlined,
  ProfileOutlined,
  StarOutlined,
  UserOutlined
} from '@ant-design/icons';

const ICONS = {
  calendar: CalendarOutlined,
  car: CarOutlined,
  clear: ClearOutlined,
  coffee: CoffeeOutlined,
  environment: EnvironmentOutlined,
  skin: SkinOutlined,
  sun: SunOutlined,
  tool: ToolOutlined,
  clock: ClockCircleOutlined,
  close: CloseCircleOutlined,
  euro: EuroOutlined,
  file: FileTextOutlined,
  heart: HeartOutlined,
  home: HomeOutlined,
  key: KeyOutlined,
  medicine: MedicineBoxOutlined,
  message: MessageOutlined,
  profile: ProfileOutlined,
  star: StarOutlined,
  user: UserOutlined
};

const StyledTile = styled.span`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: var(--ds-radius-sm);
  font-size: 15px;
  background: var(--ds-cambridge-tint);
  color: var(--ds-cambridge-dark);
`;

/**
 * Icon tile used in card titles and section menus.
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.icon - Icon name (see ICONS).
 * @returns {JSX.Element} - The CardTitleIcon component.
 */
export const CardTitleIcon = ({ icon }) => {
  const Icon = ICONS[icon] || ProfileOutlined;

  return (
    <StyledTile>
      <Icon />
    </StyledTile>
  );
};

const StyledTitle = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 12px;
`;

/**
 * Title of a card: icon tile followed by the text.
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.icon - Icon name (see ICONS).
 * @param {React.ReactNode} props.children - Title text.
 * @returns {JSX.Element} - The CardTitle component.
 */
export const CardTitle = ({ icon, children }) => (
  <StyledTitle>
    <CardTitleIcon icon={icon} />
    {children}
  </StyledTitle>
);

CardTitleIcon.propTypes = {
  icon: PropTypes.string
};

CardTitleIcon.defaultProps = {
  icon: 'profile'
};

CardTitle.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node
};

CardTitle.defaultProps = {
  icon: 'profile',
  children: null
};
